import React from 'react';
import { Box, Text } from 'grommet';
import ChartLink from './ChartLink';
import { SkeletonText } from './ChartSkeleton';

export const ChartSwatch = ({ color }) => (
    <Box width="10px" height="10px" round="2px" background={color} flex={false} />
);

// A number directly under its label, so the two read as one thing. While loading the label stays,
// since it never changes. A label that does depend on the data is left out and drawn as a block.
// With no value, `empty` says why in plain text: "None yet" at full size reads as a shout.
const ChartFigure = ({ label, value, note, swatch, href, isLoading, empty }) => {
    if (!isLoading && value == null && empty) {
        return (
            <Box>
                <Box direction="row" gap="xsmall" align="center">
                    {swatch}
                    <Text color="text-weak">{label}</Text>
                </Box>
                <Text color="text-weak">{empty}</Text>
            </Box>
        );
    }
    const number = <Text size="34px" weight={600} color="text" style={{ lineHeight: 1.15 }}>{value}</Text>;
    return (
        <Box>
            {label ? (
                <Box direction="row" gap="xsmall" align="center">
                    {swatch}
                    <Text color="text-weak">{label}</Text>
                </Box>
            ) : <SkeletonText width="48px" />}
            {isLoading
                ? <SkeletonText width="112px" height="28px" lineHeight="39px" />
                : (href ? <ChartLink href={href} label={number} /> : number)}
            {isLoading
                ? note && <SkeletonText width="136px" lineHeight="20px" />
                : note && <Text size="small" color="text-weak">{note}</Text>}
        </Box>
    );
};

export default ChartFigure;
